/*
 * パスワード表示（ログイン）
 */
const pwdLogin = document.getElementById('CustomerPassword');
const pwdLoginCheck = document.getElementById('customer-password-check');
pwdLoginCheck.addEventListener('change', function() {
    if(pwdLoginCheck.checked) {
        pwdLogin.setAttribute('type', 'text');
    } else {
        pwdLogin.setAttribute('type', 'password');
    }
}, false);